import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, UUID, ITEM, NUMBER } from '@/plugins/sdk/fields'
import Carrier from '@/plugins/sdk/resources/Carrier'
import Location from '@/plugins/sdk/resources/Dictionary/Location'
import Zone from '@/plugins/sdk/resources/Dictionary/Zone'
import Hub from '@/plugins/sdk/resources/Dictionary/Hub'
import Ldap from '@/plugins/sdk/resources/User/Ldap'

export default class extends Resource {
  static name = 'locationcarrierzone'

  static get fields () {
    return {
      id: new UUID(),
      carrier: new ITEM(Carrier),
      location: new ITEM(Location),
      zone: new ITEM(Zone),
      zone_parent: new ITEM(Zone),
      hub: new ITEM(Hub),
      user: new ITEM(Ldap),
      zone_remote: new NUMBER(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME()
    }
  }
}
